import { useEffect } from 'react';

import { FontData, InterappData } from '../types/text';
import getQueryParamValue from '../utils/queryParams';
import decodeQueryData from '../utils/decodeQueryData';

import { useFontDataHistory } from './editHistory/useFontDataHistory';

export default function useEditorData(
  setEditorData: (text: FontData) => void,
  setEditorExpanded: (b: boolean) => void,
) {
  const setHistory = useFontDataHistory((state) => state.setAll);

  useEffect(() => {
    const queryData = getQueryParamValue('t');

    if (queryData) {
      const { fontData, editorExpanded, history } = decodeQueryData(queryData) as InterappData;
      setEditorExpanded(editorExpanded);
      setEditorData(fontData);
      setHistory(history);
    }
  }, []);
}
